module.exports = __webpack_public_path__ + "img/golbal_pic.0959f473.jpg";